module.exports = __webpack_public_path__ + "static/media/mulher-olhando-o-celular.36ee9c83.png";